/*
 * @Author: wuchenge
 * @Date:   2022-04-06 18:52:00
 * @Last Modified by:   无尘阁
 * @Last Modified time: 2022-04-06 18:52:23
 */
import Loadable from "react-loadable";

export default (loader) => {
  return Loadable({
    loader,
    loading() {
      return <div>正在加载</div>;
    },
  });
};
